import { httpClient } from 'shared/services/api/httpClient';
import { mockDelay } from 'shared/services/api/mockDelay';
import { USE_MOCK_API } from 'shared/services/api/config';

// Elimina o if/else "USE_MOCK_API ? mock : httpClient..." repetido em todo *Service.ts.
// Cada service só precisa dizer QUAL mock e QUAL rota — a decisão de qual usar mora aqui.
export function apiGet<T>(mockData: T, path: string, delayMs = 350): Promise<T> {
  return USE_MOCK_API ? mockDelay(mockData, delayMs) : httpClient.get<T>(path);
}

export function apiPost<T>(mockResult: T, path: string, body?: unknown, delayMs = 250): Promise<T> {
  return USE_MOCK_API ? mockDelay(mockResult, delayMs) : httpClient.post<T>(path, body);
}

export function apiPatch<T>(mockResult: T, path: string, body?: unknown, delayMs = 200): Promise<T> {
  return USE_MOCK_API ? mockDelay(mockResult, delayMs) : httpClient.patch<T>(path, body);
}
